<template>
  <div class="town town_header" :class="{ town_active: showCitySelect }" id="cities">

    <a class="town__link" href="#" @click="onCitySelectClick">
      <svg class="geo-icon" width="14px" height="16px">
        <use xlink:href="#geo"></use>
      </svg>
      {{name}}
    </a>

    <CitySubmit
      :showCityConfirm="showCityConfirm"
      :showCitySelect="() => {
        doShowCitySelect()
      }"
      :submitConfirmCity="() => {
        confirm();
        persist();
      }"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import CitySubmit from './CitySubmit.vue';
import { factory as citySelectFactory } from './CitySelect.vue';

import { getters as cityGetters, mutations as cityMutations, actions as cityActions } from '../../store/city.store';

Vue.prototype.Object = Object; // eslint-disable-line

export default {
  name: 'UserCity',
  components: {
    CitySubmit,
  },
  data() {
    return {
      showCitySelect: false,
    };
  },
  computed: {
    ...cityGetters, // name(), code(), confirmed()
    showCityConfirm() {
      // Если город установлен, но не подтвержден, нужно показать диалог подтверждения
      return !!(cityGetters.code() && !cityGetters.confirmed());
    },
  },
  watch: {
    name: {
      handler(val, oldVal) {
        if (val !== oldVal) {
          const HREF = '/kontakty/napisat-pis-mo-v-sluzbu-podderzki/voprosy-po-kur-erskoj-dostavke-po-g-moskva-i-gorodam-sputnikam';
          const CLASS_HIDDEN = 'hidden';

          document.querySelectorAll(`.tabs__submenu-item[href="${HREF}"]`)
            .forEach((submenuItem) => {
              if (val === 'Москва') {
                submenuItem.classList.remove(CLASS_HIDDEN);
              } else {
                submenuItem.classList.add(CLASS_HIDDEN);
              }
            });
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.citySelectDlg = citySelectFactory();
    this.citySelectDlg.$on('select', (city) => {
      this.citySelectDlg.hide();

      this.selectCity(city);
    });
    this.citySelectDlg.$on('hide', () => {
      this.showCitySelect = false;
    });
  },
  created() {
    const self = this;

    this.citySelectDlg = null;

    window.addEventListener('keydown', (e) => {
      // Закрываем всех по очереди по ESC
      if (e.code === 'Escape') {
        if (!self.showCitySelect && self.showCityConfirm) {
          self.showCityConfirm = false;
        }

        if (self.showCitySelect) {
          self.showCitySelect = false;
          if (self.citySelectDlg) {
            self.citySelectDlg.hide();
          }
        }
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('keydown', () => {});
  },
  methods: {
    ...cityMutations, // city(), confirm()
    ...cityActions, // persist()
    selectCity(city) {
      this.setCity(city);
      this.confirm();
      this.persist();
    },
    doShowCitySelect() {
      this.showCitySelect = true;
      if (this.citySelectDlg) {
        this.citySelectDlg.show();
      }
    },
    onCitySelectClick(e) {
      this.doShowCitySelect();

      e.preventDefault();
    },
  },
};
</script>
